import type { User } from "../store/accountReducer";

export type InternalFeature = "charterAnalytics" | "fleetMap";

const DEFAULT_INTERNAL_FEATURE_ROLES = ["agent", "admin", "administrator"];

const isEnabledValue = (value: string | undefined) =>
  value ? value.trim().toLowerCase() === "true" : false;

export const internalFeatureLabels: Record<InternalFeature, string> = {
  charterAnalytics: "Charter Analytics",
  fleetMap: "Fleet Map",
};

export const internalFeatureFlags: Record<InternalFeature, boolean> = {
  charterAnalytics: import.meta.env.DEV || isEnabledValue(import.meta.env.VITE_ENABLE_CHARTER_ANALYTICS),
  fleetMap: import.meta.env.DEV || isEnabledValue(import.meta.env.VITE_ENABLE_FLEET_MAP),
};

export const isInternalFeatureEnabled = (feature: InternalFeature) => internalFeatureFlags[feature];

export const getInternalFeatureRoles = () => {
  const configuredRoles = import.meta.env.VITE_INTERNAL_FEATURE_ROLES;
  if (!configuredRoles) return DEFAULT_INTERNAL_FEATURE_ROLES;

  const roles = configuredRoles
    .split(",")
    .map((role) => role.trim().toLowerCase())
    .filter(Boolean);

  return roles.length ? roles : DEFAULT_INTERNAL_FEATURE_ROLES;
};

export const userCanAccessInternalFeature = (
  user: Pick<User, "isAgent" | "role"> | null | undefined,
  allowedRoles = getInternalFeatureRoles()
) => {
  if (!allowedRoles.length) return true;
  if (user?.isAgent && allowedRoles.includes("agent")) return true;

  const role = user?.role?.trim().toLowerCase();
  if (!role) return false;

  return allowedRoles.some((allowedRole) => role.includes(allowedRole));
};
